import { Text } from "@mantine/core";
import { type FragmentOf, graphql, readFragment } from "gql.tada";

import { EffectRow } from "./EffectRow";

export const RuleEngineEffectEliminateFragment = graphql(`
  fragment RuleEngineEffectEliminateFields on RuleEngineEffectEliminatePayload {
    __typename
    effectKind
    targetTeamId
    stepId
    beforeStatus
    afterStatus
    applied
    skipReason
  }
`);

interface Props {
  data: FragmentOf<typeof RuleEngineEffectEliminateFragment>;
}

export function RuleEngineEffectEliminatePayload({ data }: Props) {
  const p = readFragment(RuleEngineEffectEliminateFragment, data);
  return (
    <EffectRow
      applied={p.applied}
      appliedColor="red"
      appliedLabel="ELIMINATED"
      skipReason={p.skipReason}
    >
      team {p.targetTeamId.slice(0, 8)}: {p.beforeStatus} → {p.afterStatus}
      {" · "}
      <Text span size="xs" c="dimmed">
        step {p.stepId.slice(0, 8)}
      </Text>
    </EffectRow>
  );
}
